import config from '@/config';

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  CONTENT_TYPE_JSON: 'application/json',
  AUTH_HEADER: 'Authorization',
  TOKEN_KEY: 'pnAccessToken',
} as const;

// Keep all endpoint paths in one place. Add to this object as API surface grows.
export const API_URLS = {
  health: '/health',
  loginUrl: `${config.VUE_APP_AUTH_API}/oauth2/auth`,
  logoutUrl: `${config.VUE_APP_AUTH_API}/oauth2/sessions/logout`,
  authToken: `${config.VUE_APP_AUTH_API}/oauth2/token`,
  currentUser: '/test/userdetails',
  sampleAddressTemplate: '/sampleAddress',
  getPostCardDetails: '/serviceCards',
  generatePresignedUpload: '/generatePresigned',
  pdfGeneratePresigned: `${config.VUE_APP_AWS_API}/pdfUpload`,
  pdfValidate: `${config.VUE_APP_AWS_API}/pdfValidate`,
  pdfPreview: `${config.VUE_APP_AWS_API}/preview`,
  flattenPdf: `${config.VUE_APP_AWS_API}/pdfFlatten`,
  calculatePrice: '/calculatePrice',
  validateAddressStream: `${API_CONFIG.BASE_URL}/streaming`,
  getHolidays: `${config.VUE_APP_AWS_API}/holiday`,
  getProducts: `${config.VUE_APP_AWS_API}/getProducts`,
  createOrder: '/orders',
  getMyOrders: '/orders',
  getCustomers: '/customers',
  getPaymentMethods: '/paymentMethods',
  activateOrder: (orderId: string, suOrderId: string) => `/orders/${orderId}/activate?orderId=${suOrderId}`,
  getReceipt: '/getReceiptPdf'
} as const;
